import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var BraceRight = props => {
  var {
    BraceRight: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BraceRight');
  return null;
};
BraceRight.displayName = 'JVR.BraceRight';